import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PlatformLayout from "./components/PlatformLayout";
import PlatformLogin from "./pages/PlatformLogin";
import Tenants from "./pages/Tenants";
import Releases from "./pages/Releases";
import { Overview, PlatformUsers, RegulatoryLibrary, AuditLog, PlatformSettings } from "./pages/PlatformPages";
import { isPlatformAuthed } from "./auth";

function Guard({ children }) {
  return isPlatformAuthed() ? <PlatformLayout>{children}</PlatformLayout> : <Navigate to="/login" replace />;
}

export default function AdminApp() {
  return (
    <Routes>
      <Route path="/login" element={<PlatformLogin />} />
      <Route path="/" element={<Guard><Tenants /></Guard>} />
      <Route path="/releases" element={<Guard><Releases /></Guard>} />
      <Route path="/overview" element={<Guard><Overview /></Guard>} />
      <Route path="/users" element={<Guard><PlatformUsers /></Guard>} />
      <Route path="/regulatory" element={<Guard><RegulatoryLibrary /></Guard>} />
      <Route path="/audit" element={<Guard><AuditLog /></Guard>} />
      <Route path="/settings" element={<Guard><PlatformSettings /></Guard>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
